import {PackingService,OrderService} from "../resource";

const PackingModule = {
    namespaced: true,
    state: {
        datas: []
    },
    mutations: {
        SET_DATA(state, data) {
            state.datas = data;
        }
    },
    actions: {
        shippingCreateAndClose({ commit, state }, data) {
            return PackingService.ShippingCreateAndClose(data);
        },
        shippingCreateAndCloseWithCoupon({ commit, state }, data) {
            return PackingService.ShippingCreateAndCloseWithCoupon(data);
        },

        shippingLinkCoupon({ commit, state }, data) {
            return PackingService.ShippingLinkCoupon(data);
        },
        createData({ commit, state }, data) {
            return PackingService.PackingCreate(data);
        },
		deleteData({ commit, state }, data) {
            return PackingService.PackingDelete(data);
        },

        async listData({ commit, state }, data) {
			console.log("packing list")
            try {
                const response = await PackingService.PackingList(data);
				commit("SET_DATA", response.data.Data != null ? response.data.Data : []);

            } catch (error) {
                commit("SET_DATA", []);
            }
        },

		listOrder({ commit, state }, params){
				return  OrderService.ListOrder(params);
		},
        shippingData({ commit, state }, data) {
            return PackingService.PackingShipping(data);
        },

        getShippingDocument({ commit, state }, data) {
            return PackingService.PackingGetDocument(data);
        },

        getShippingDocumentV2({ commit, state }, data) {
            return PackingService.PackingGetDocumentV2(data);
        },

		addPickupItem({ commit, state }, data) {
			return PackingService.PickupItemAdd(data)
		},

		removePickupItem({ commit, state }, data) {
			return PackingService.PickupItemRemove(data)
		},

		closeShippingOrder({ commit, state }, data) {
			return PackingService.ShippingClose(data)
		},

		createReturn({ commit, state }, data) {
			return PackingService.ReturnCreate(data)
		},
		closeReturn({ commit, state }, data) {
			return PackingService.ReturnClose(data)
		},


		AdminAddPickupItem({ commit, state }, data) {
			return PackingService.AdminPickupItemAdd(data)
		},

		AdminClearPickupItem({ commit, state }, data) {
			return PackingService.AdminPickupItemClear(data)
		},

		AdminCloseShippingOrder({ commit, state }, data) {
			return PackingService.AdminShippingClose(data)
		},

		ShippingCheckIsClose({ commit, state }, data) {
			return PackingService.ShippingCheckIsClose(data)
		},

		ClearFailTracking({ commit, state }, id) {
			return PackingService.ClearFailTracking(id)
		},
        

    },
    getters: {
        getData(state) {
            return state.datas;
        }
    }
};

export default PackingModule;
